import { Container } from './styles';

export function CustomersDashboard() {
  return (
    <Container>
      <h1>CustomersDashboard</h1>
    </Container>
  );
};
